// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pj_so{align-self:flex-end;max-width:85%;padding-inline:8px}.Pj_so.iSwV4{align-self:flex-start;max-width:100%}.I8uyZ{display:flex;flex-direction:column;gap:4px;align-items:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Pj_so`,
	"leftAligned": `iSwV4`,
	"pdfMessage": `I8uyZ`
};
export default ___CSS_LOADER_EXPORT___;
